import useReactRouter from 'use-react-router';
import {
  History,
  LocationState,
  Location,
  LocationDescriptorObject,
  createLocation,
  LocationDescriptor,
} from 'history';
import { useCallback } from 'react';
import qs from 'query-string';

import { useCondensedQueryParameters } from 'hooks/useQueryParameters';

export const mergeLocation = (
  params: object,
  descriptor: LocationDescriptor,
  state?: LocationState,
): Location => {
  const oldLocation = createLocation(descriptor, state);
  return {
    ...oldLocation,
    search: oldLocation.search || qs.stringify(params),
  };
};

type NavigationHelpersHook = () => Pick<
  History,
  'push' | 'replace' | 'go' | 'goBack' | 'goForward'
>;
const useNavigationHelpers: NavigationHelpersHook = () => {
  const { history } = useReactRouter();
  const queryParameters = useCondensedQueryParameters();

  const push: History['push'] = useCallback(
    (path: string | LocationDescriptorObject, state?: LocationState) => {
      return history.push(mergeLocation(queryParameters, path, state));
    },
    [history, queryParameters],
  );

  const replace: History['replace'] = useCallback(
    (path: string | LocationDescriptorObject, state?: LocationState) => {
      return history.replace(mergeLocation(queryParameters, path, state));
    },
    [history, queryParameters],
  );

  return {
    push,
    replace,
    go: history.go,
    goBack: history.goBack,
    goForward: history.goForward,
  };
};

export default useNavigationHelpers;
